/**
 * Analytics Module
 * Main exports for all analytics functions and utilities
 */

// DataLayer
export {
  bootstrap_analytics,
  is_analytics_initialized,
  reset_initialization_state,
  get_initialization_status
} from './datalayer.js';

// Push utilities
export {
  initialize_data_layer,
  push_to_data_layer,
  get_data_layer,
  clear_data_layer,
  get_data_layer_size,
  get_data_layer_tail,
  batch_push_to_data_layer
} from './pushToDataLayer.js';

// Events
export {
  track_event,
  track_support_search,
  track_category_click,
  track_product_click,
  track_file_download,
  track_menu_click,
  track_cta_click,
  track_hyperlink_click,
  track_product_tab_click,
  track_filter_click,
  track_slider_click,
  track_breadcrumb_click,
  track_homepage_view
} from './events.js';

// Validators
export {
  validate_event_name,
  validate_payload_structure,
  validate_no_pii,
  validate_required_fields,
  validate_event
} from './validators.js';

// Priorities
export {
  should_block_event,
  record_event,
  clear_event_history,
  get_event_history
} from './priorities.js';

// Constants
export {
  ANALYTICS_CONFIG,
  DEVICE_TYPES,
  EVENT_NAMES,
  EVENT_PRIORITIES,
  PAGEVIEW_EVENT
} from './constants.js';

// Device detection
export {
  detect_device_type,
  create_device_listener
} from './device.js';

// Page context
export {
  initialize_page_context,
  update_page_context,
  get_page_context,
  build_site_context,
  build_context_payload
} from './pageContext.js';

// GTM integration
export {
  load_gtm,
  send_event_to_gtm,
  is_gtm_loaded,
  set_gtm_config,
  get_gtm_status,
  GTM_CONFIG
} from './gtm.js';

// Route tracking
export {
  setup_route_tracking,
  setup_route_tracking_with_guard,
  track_pageview,
  track_scroll_depth,
  track_time_on_page
} from './routeTracker.js';
